import React from "react";
import licenses from "spdx-license-list/full";
import software from "@lib/staticData/licenses.json";

const ADDITIONAL_SOFTWARE = {
  LanguageTool: {
    licenses: "LGPL-2.1",
    repository: "https://github.com/languagetool-org/languagetool",
    publisher: "LanguageTool.org",
  },
};
const ALL_SOFTWARE = {
  ...software,
  ...ADDITIONAL_SOFTWARE,
};

function Licenses() {
  return (
    <div className="p-12">
      <h1 className="font-bold text-3xl">Lizenzen</h1>
      <p className="mb-6">
        Diese Seite enthält eine Liste von Softwarelizenzen, die von uns
        verwendet werden.
      </p>

      {Object.keys(ALL_SOFTWARE).map((softwareName) => {
        const softwareDetails =
          ALL_SOFTWARE[softwareName as keyof typeof ALL_SOFTWARE];
        const licenseName =
          typeof softwareDetails.licenses === "string"
            ? softwareDetails.licenses
            : softwareDetails.licenses[0];
        const softwareLicense = licenses[licenseName];
        const softwareUrl =
          // @ts-ignore
          softwareDetails.repository ?? softwareDetails.url ?? false;

        return (
          <div key={softwareName} className="mt-6">
            <h2 className="font-bold text-xl">{softwareName}</h2>
            <p>
              This product includes &quot;{softwareName}&quot;
              {softwareUrl && (
                <span>
                  (
                  <a href={softwareUrl} className="text-blue-400 underline">
                    {softwareUrl}
                  </a>
                  )
                </span>
              )}
              . The following license applies to this software:
            </p>

            <pre className="bg-slate-100 rounded max-h-64 overflow-scroll p-3">
              {softwareLicense?.licenseText
                .replace("<year>", String(new Date().getFullYear()))
                .replace(
                  "<copyright holders>",
                  // @ts-ignore
                  softwareDetails.publisher ?? ""
                )}
            </pre>
          </div>
        );
      })}
    </div>
  );
}

export { getStaticProps } from "@lib/utils/translationsStaticProps";

export default Licenses;
